const style = (theme) => {
  const output = {
    root: {
      extend: theme.smallWrapper,
    },
    title: {
      color: theme.colors[4],
      fontFamily: theme.fonts[1],
      fontWeight: 100,
      lineHeight: 1,
      fontSize: '5vw',
    },
    text: {
      color: theme.colors[1],
      fontSize: 16,
      marginTop: 20,
      width: '60%',
    },
    list: {
      display: 'flex',
      flexWrap: 'wrap',
      marginLeft: -25,
      marginRight: -25,
      '& > *': {
        width: '25%',
        paddingLeft: 25,
        paddingRight: 25,
      },
    },
    item: {
      marginTop: 60,
      '& h3': {
        color: theme.colors[1],
        fontWeight: 800,
        textTransform: 'uppercase',
        fontSize: 10,
        marginBottom: 20,
      },
      '& p': {
        color: theme.colors[1],
        fontWeight: 300,
        fontSize: 17,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    text: {
      width: '100%',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    title: {
      fontSize: 70,
    },
    list: {
      '& > *': {
        width: '100%',
        '&:not(:last-child)': {
          marginBottom: 25,
        },
      },
    },
  }

  return output
}

export default style
